import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

Vue.use(Router);

var routes = [
  {
    path: "/Login",
    component: () => import("@/pages/Login"),
  },
  {
    path: "/",
    redirect: "/Reports",
  },
  {
    path: "/Reports",
    component: () => import("@/pages/Index"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Companies",
    component: () => import("@/pages/Companies"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Swagger",
    component: () => import("@/pages/Swagger"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Hangfire",
    component: () => import("@/pages/Hangfire"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Companies/Configuration/:companyId",
    component: () => import("@/pages/Configuration"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Reports/LastWeekConfirmReservation",
    component: () => import("@/pages/LastWeekConfirmReservation"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Reports/TodayReservation",
    component: () => import("@/pages/TodayReservation"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Mails",
    component: () => import("@/pages/Mails"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Mails/SendMails",
    component: () => import("@/pages/SendMails"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Companies/Operations/:companyId",
    component: () => import("@/pages/Operations"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Companies/Operations/:companyId/Slots/:operationId",
    component: () => import("@/pages/Slots"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Users",
    component: () => import("@/pages/Users"),
    beforeEnter: guardRoute,
  },
  {
    path: "/CompanyUsers/:userId",
    component: () => import("@/pages/CompanyUsers"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Account/ChangePassword",
    component: () => import("@/pages/Account/ChangePassword"),
    beforeEnter: guardRoute,
  },
  {
    path: "/CancelReservations",
    component: () => import("@/pages/CancelReservations"),
    beforeEnter: guardRoute,
  },
  {
    path: "/GlobalWhiteList",
    component: () => import("@/pages/GlobalWhiteList"),
    beforeEnter: guardRoute,
  },
  {
    path: "/Locales",
    component: () => import("@/pages/Locales"),
    beforeEnter: guardRoute,
  },
  {
    name: "Translations",
    path: "/Locales/Translations/:companyId",
    component: () => import("@/pages/Translations"),
    beforeEnter: guardRoute,
  },
];

const router = new Router({
  base: "/",
  mode: "history",
  routes,
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((error) => router.go(0));
};

function guardRoute(to, from, next) {
  if (store.getters.isLoggedIn) {
    next();
  } else {
    next({ path: "/login" });
  }
}

export default router;
